import { autolinkInputRule, insertLinkInputRule, pasteUrlPlugin } from '../input_rules';
import { customLinkSchema } from '../schemas';
// flattened to ensure all plugins are in the root array
export const linkPlugin = [
    customLinkSchema,
    insertLinkInputRule,
    autolinkInputRule,
    pasteUrlPlugin,
].flat();
//# sourceMappingURL=linkPlugin.js.map